import(/* webpackMode: "eager" */ "/var/www/html/cliquefatos-headless/src/app/(web)/error.js");
